import {
  GridFooterContainer,
  GridSelectedRowCount,
  gridRowSelectionCountSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-premium';
import { cn } from 'cn';
import { type ReactNode } from 'react';

import { Pagination } from './Pagination';

declare module '@mui/x-data-grid-premium' {
  interface FooterPropsOverrides {
    selectedRowsActions?: ReactNode;
  }
}

export function Footer({
  className,
  selectedRowsActions,
}: {
  className?: string;
  selectedRowsActions?: ReactNode;
}) {
  const apiRef = useGridApiContext();
  const selectedRowCount = useGridSelector(
    apiRef,
    gridRowSelectionCountSelector,
  );

  return (
    <GridFooterContainer
      className={cn('justify-between border-t-0', className)}
    >
      <div className="flex min-w-0 flex-1 items-center gap-2">
        {!!selectedRowCount && (
          <>
            <div className="shrink-0 whitespace-nowrap">
              <GridSelectedRowCount selectedRowCount={selectedRowCount} />
            </div>
            <div className="min-w-0 overflow-y-auto">
              {selectedRowsActions ?? null}
            </div>
          </>
        )}
      </div>
      <div className="shrink-0">
        <Pagination />
      </div>
    </GridFooterContainer>
  );
}
